import React from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import dayjs from 'dayjs';
// import { useTranslation } from 'react-i18next';

export const LineMulti = ({ data, list, theme }) => {
  // const { t } = useTranslation('');

  const getTortfolio = (id) => {
    const portfolio = list?.find((i) => i.id === +id);
    return portfolio;
  };

  const getTimeToString = (date) => dayjs(date).format('YYYY-MM');

  const series = data
    ? Object.entries(data).map(([portfolioId, { value_development }]) => ({
        name: `Portfolio ${getTortfolio(portfolioId)?.name}`,
        data: value_development
          ?.map((item) => ({
            x: new Date(item.year, item.month - 1).getTime(),
            y: item.indexed_value,
          }))
          ?.sort((a, b) => a.x - b.x),
        color: getTortfolio(portfolioId)?.color || '#FB7B34',
        marker: { enabled: false },
      }))
    : [];

  const options = {
    chart: {
      type: 'line',
      height: 420,
      backgroundColor: 'transparent',
    },
    accessibility: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: true,
    },
    title: {
      text: null,
    },
    xAxis: {
      gridLineColor: 'rgba(0, 0, 0, 0)',
      labels: {
        type: 'datetime',
        style: { color: theme === 'dark-theme' ? '#B0B0B0' : '#000000' },
        formatter: function () {
          return getTimeToString(this.value);
        },
      },
    },
    yAxis: {
      gridLineColor: 'rgba(0, 0, 0, 0)',
      labels: {
        style: { color: theme === 'dark-theme' ? '#B0B0B0' : '#000000' },
      },
    },
    plotOptions: {
      series: {
        animation: true,
      },
    },
    tooltip: {
      formatter: function () {
        return `${dayjs(this.x).format('YYYY-MM')}: <b>${this.y}</b>`;
      },
    },
    series: series,
    responsive: {
      rules: [
        {
          condition: {
            // maxWidth: 970
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom',
            },
          },
        },
      ],
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

LineMulti.propTypes = {
  data: PropTypes.object,
  list: PropTypes.array,
  theme: PropTypes.string,
};
